import { sendGTMEvent } from '@next/third-parties/google'
import type { HydraErrorType } from '@/lib/services/Hydra/_hydraError'
import { mapUrlToEventLocation } from '../../helpers/mapUrlToEventLocation'

export type GtmCreateAccountServerError = {
  error: HydraErrorType
}

export const gtmCreateAccountServerError = ({
  error,
}: GtmCreateAccountServerError) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_create_account_server_error',
    event_id: uuid,
    event_location: mapUrlToEventLocation(window.location.href),
    response_code: error.error?.code,
    error_message: error.error?.error_message || error.error?.message,
  })
}
